import React from 'react';

import {
  Colors,
} from '@noitada/shared/constants';

import {
  Input,
} from '../Composh/web';



export interface IProps {
  password?: any;
  disabled?: any;
  autoCapitalize?: any;
  autoCorrect?: any;
  type?: any;
  backgroundColor?: any;
  iconLeft?: any;
  iconRight?: any;
  labelText?: any;
  placeholderColor?: any;
  inputTextColor?: any;
  placeholderText?: any;
  helpText?: any;
  countLimit?: any;
  borderColor?: any;
  value?: any;
  onChange?: any;
  onBlur?: any;
  options?: any;
}



const InputText: React.FC<IProps> = (props: IProps) => {
  return (

    <Input.Text
      disabled={props.disabled}
      password={props.password}
      options={props.options}
      autoCorrect={props.autoCorrect}
      autoCapitalize={props.autoCapitalize}
      type={props.type}
      backgroundColor={props.backgroundColor || '#343543'}
      iconLeft={props.iconLeft}
      iconRight={props.iconRight}
      labelText={props.labelText}
      labelColor={Colors.primary}
      placeholderText={props.placeholderText}
      placeholderTextColor={props.placeholderColor || Colors.textSubtitle}
      inputTextColor={props.inputTextColor || Colors.textApp}
      helpText={props.helpText}
      helpColor={Colors.danger}
      countLimit={props.countLimit}
      countColor={Colors.textDescription}
      borderColor={props.helpText
        ? Colors.danger
        : props.borderColor ?
          props.borderColor
          : null
      }
      value={props.value}
      onChange={props.onChange}
      onBlur={props.onBlur}
    />

  );
};



export default InputText;
